import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiPlus, FiEdit2, FiTrash2, FiEye } from 'react-icons/fi';
import { UseToast } from '../../hooks/UseToast';
import Button from '../../components/ui/Button';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

const ProjectsList = () => {
  const navigate = useNavigate();
  const toast = UseToast();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/projects`);
      const data = await res.json();
      
      console.log('API Response:', data); // ✅ Debug ku
      
      if (data.success) {
        setProjects(data.data || []); // ✅ data.data use pannu
      } else {
        toast.error('Failed to load projects');
        setProjects([]);
      }
    } catch (error) {
      toast.error('Server error');
      console.error('Fetch error:', error);
      setProjects([]);
    }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this project?')) return;
    
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/projects/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      const data = await res.json();
      
      if (data.success) {
        toast.success('Project deleted successfully!');
        setProjects(projects.filter(p => p._id!== id));
      } else {
        toast.error(data.message || 'Delete failed');
      }
    } catch (error) {
      toast.error('Something went wrong');
      console.error('Delete error:', error);
    }
  };

  // ✅ Safe filter + title use pannu, name illa
  const filteredProjects = (projects || []).filter(p => 
    p.title?.toLowerCase().includes(searchTerm.toLowerCase()) || // title use pannu
    p.client?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    p.category?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('en-IN');
  };

  return (
    <>
      <style>{`
  .page-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 30px; }
  .page-title { font-size: 32px; font-weight: 800; color: #0F172A; margin: 0; }
  .table-card { background: #FFF; border-radius: 16px; padding: 30px; box-shadow: 0 4px 20px rgba(0,0,0,0.06); }
  .table-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
  .search-input { padding: 10px 16px; border: 2px solid #E2E8F0; border-radius: 10px; width: 300px; font-size: 14px; transition: all 0.3s ease; }
  .search-input:focus { outline: none; border-color: #3B82F6; box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1); }
  .data-table { width: 100%; border-collapse: collapse; }
  .data-table th { text-align: left; padding: 12px; font-size: 13px; font-weight: 700; color: #64748B; text-transform: uppercase; border-bottom: 2px solid #E2E8F0; }
  .data-table td { padding: 16px 12px; border-bottom: 1px solid #F1F5F9; font-size: 14px; }
  .data-table tr:hover { background: #F8FAFC; }
  .action-btns { display: flex; gap: 8px; }
  .icon-btn { width: 36px; height: 36px; border-radius: 8px; border: none; display: flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.3s ease; }
  .icon-btn.edit { background: #DBEAFE; color: #1E40AF; }
  .icon-btn.edit:hover { background: #3B82F6; color: #FFF; transform: translateY(-2px); }
  .icon-btn.delete { background: #FEE2E2; color: #991B1B; }
  .icon-btn.delete:hover { background: #EF4444; color: #FFF; transform: translateY(-2px); }
  .icon-btn.view { background: #D1FAE5; color: #065F46; }
  .icon-btn.view:hover { background: #10B981; color: #FFF; transform: translateY(-2px); }
  .status-badge { padding: 4px 12px; border-radius: 20px; font-size: 12px; font-weight: 600; display: inline-block; }
  .status-completed { background: #D1FAE5; color: #065F46; }
  .status-progress { background: #DBEAFE; color: #1E40AF; }
  .status-hold { background: #F3F4F6; color: #6B7280; }
  .status-cancelled { background: #FEE2E2; color: #991B1B; }
  .empty-state { text-align: center; padding: 60px 20px; }
  .empty-icon { font-size: 64px; margin-bottom: 16px; opacity: 0.5; }
  .loading-state { text-align: center; padding: 60px 20px; color: #64748B; }
      @media (max-width: 768px) {
     .page-header { flex-direction: column; align-items: flex-start; gap: 16px; }
     .search-input { width: 100%; }
     .table-card { padding: 16px; overflow-x: auto; }
      }
      `}</style>
      <div>
        <div className="page-header">
          <h1 className="page-title">Projects</h1>
          <Button onClick={() => navigate('/projects/add')} icon={<FiPlus />}>
            Add Project
          </Button>
        </div>
        
        <div className="table-card">
          <div className="table-header">
            <input 
              type="text" 
              className="search-input" 
              placeholder="Search projects..." 
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <span style={{ fontSize: '14px', color: '#64748B' }}>
              {filteredProjects.length} projects
            </span>
          </div>
          
          {loading? (
            <div className="loading-state">Loading projects...</div>
          ) : filteredProjects.length === 0? (
            <div className="empty-state">
              <div className="empty-icon">📁</div>
              <p style={{ fontSize: '16px', fontWeight: '600', color: '#0F172A' }}>
                {searchTerm? 'No projects found' : 'No projects yet'}
              </p>
              <p style={{ fontSize: '14px', color: '#64748B' }}>
                {searchTerm? 'Try a different search' : 'Create your first project to get started'}
              </p>
            </div>
          ) : (
            <table className="data-table">
              <thead>
                <tr>
                  <th>Project Name</th>
                  <th>Category</th>
                  <th>Client</th>
                  <th>Status</th>
                  <th>Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredProjects.map((p) => (
                  <tr key={p._id}>
                    <td><strong>{p.title}</strong></td> {/* ✅ title use pannu */}
                    <td>{p.category}</td>
                    <td>{p.client}</td>
                    <td>
                      <span className="status-badge status-progress">
                        Active
                      </span>
                    </td>
                    <td>{formatDate(p.createdAt)}</td>
                    <td>
                      <div className="action-btns">
                        {p.liveUrl && (
                          <a 
                            href={p.liveUrl} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="icon-btn view"
                            title="View Live"
                          >
                            <FiEye />
                          </a>
                        )}
                        <button 
                          className="icon-btn edit" 
                          onClick={() => navigate(`/projects/edit/${p._id}`)}
                          title="Edit"
                        >
                          <FiEdit2 />
                        </button>
                        <button 
                          className="icon-btn delete" 
                          onClick={() => handleDelete(p._id)}
                          title="Delete"
                        >
                          <FiTrash2 />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </>
  );
};

export default ProjectsList;